import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { PropType } from 'vue'
import { IonItem, IonSelect, IonSelectOption } from '@ionic/vue';

//Emits

export default /*#__PURE__*/_defineComponent({
  __name: 'AppSelect',
  props: {
  placeholder: {
    type: String,
    required: false
  },
  items: {
    type: Array as PropType<Array<{id: string; label: string; value: string}>>,
    required: false
  },
  initialValue: {
    type: String,
    required: false
  }
},
  emits: ['valueChanged', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;



//Props


//Methods
function handleChange(event: any) {
  emit('valueChanged', event)
  emit('update:modelValue', event.detail.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), { class: "appSelect" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSelect), {
        placeholder: props.placeholder,
        value: __props.initialValue,
        onIonChange: _cache[0] || (_cache[0] = ($event: any) => (handleChange($event)))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
              key: item.id,
              value: item.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["placeholder", "value"])
    ]),
    _: 1
  }))
}
}

})